<template>
  <v-card flat rounded="lg" v-if="!isSelecPessoaJurid()">
    <v-card-title class="subtitle-1 font-weight-bold"
      >Dados Adicionais</v-card-title
    >
    <v-card-text>
      <v-form ref="form" :disabled="editar">
        <v-row>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="Nome da mãe"
              v-model="clienteManut.nomemae"
            ></v-text-field>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="Nome do pai"
              v-model="clienteManut.nomepai"
            ></v-text-field>
          </v-col>
          <template v-if="isPreencherConjuge()">
            <v-col xl="6" lg="6" md="6" cols="12">
              <v-text-field
                label="Nome do cônjuge"
                v-model="clienteManut.nomeconjuge"
              ></v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="3" cols="12">
              <v-text-field
                label="Data nascimento cônjuge"
                v-model="clienteManut.dtnasconjuge"
                type="date"
              ></v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="3" cols="12">
              <v-text-field
                label="CPF cônjuge"
                v-model="clienteManut.cpfconjuge"
                v-mask="'###########'"
              ></v-text-field>
            </v-col>
          </template>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-text-field
              label="Qtde área própria (Ha)"
              v-model="clienteManut.areapropria"
              v-mask="maskDecimal"
            ></v-text-field>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-text-field
              label="Qtde área arrendada (Ha)"
              v-model="clienteManut.areaarrendada"
              v-mask="maskDecimal"
            ></v-text-field>
          </v-col>
           <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="Vendedor"
              v-model="clienteManut.vendedor.nome"              
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

export default {
  computed: mapState("clientes", ["clienteManut","editar"]),
  data: () => ({
    maskDecimal: createNumberMask({
      prefix: "",
      includeThousandsSeparator: false,
      decimalSymbol: ".",
      allowLeadingZeroes: true,
      allowDecimal: true,
    }),
  }),
  methods: {
    ...mapGetters("clientes", ["isPreencherConjuge","isSelecPessoaJurid"]),
  },
};
</script>

<style>
</style>